module.exports = __webpack_public_path__ + "837bece01ce280c23ad567ab54210da8.svg";